module.exports = __webpack_public_path__ + "static/media/ResumePDF.00dfa9d6.pdf";